import React, {useCallback, useEffect, useState} from "react";
import ClearIcon from "@mui/icons-material/Clear";
import {Box} from "@mui/material";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";

const Page = ({title = null, id = undefined, children}) => {
  const [isOldBrowserWarningVisible, setIsOldBrowserWarningVisible] = useState(false);

  useEffect(() => {
    // Internet Explorer 6-11
    const isIE = !!document.documentMode;
    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;
    setIsOldBrowserWarningVisible(isIE || isEdge);
  }, []);

  useEffect(() => {
    if (title && title.length > 0) {
      document.title = title;
    }
  }, [title]);

  const closeWarning = useCallback(() => {
    setIsOldBrowserWarningVisible(false);
  }, []);

  return (
    <Box
      id={id}
      sx={{
        width: "100%",
        height: "100%"
      }}
    >
      {isOldBrowserWarningVisible && (
        <Box
          sx={{
            width: "100%",
            height: "100%"
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid>
              This browser in not completely supported, please consider to install the new version of{" "}
              <a
                href="https://www.microsoft.com/edge"
                target="_blank"
                rel="noopener noreferrer"
                style={{color: "white"}}
              >
                Microsoft Edge
              </a>
            </Grid>
            <Grid>
              <IconButton onClick={closeWarning} sx={{color: "white", padding: "7px"}}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
        </Box>
      )}
      <Box
        sx={{
          width: "100%",
          height: "100%"
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Page;
